import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6 19C6 11.8203 11.8203 6 19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19Z",
				stroke: "#DC6803",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .1,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19Z",
				stroke: "#DC6803",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 16.5003V19.417M19 21.917H19.0083M17.6548 12.6541L10.991 23.7704C10.6614 24.3201 10.4965 24.595 10.5206 24.8206C10.5416 25.0174 10.6472 25.1956 10.8109 25.3122C10.9986 25.4458 11.3204 25.4458 11.9642 25.4458H25.2918C25.9356 25.4458 26.2574 25.4458 26.4451 25.3122C26.6088 25.1956 26.7144 25.0174 26.7354 24.8206C26.7595 24.595 26.5946 24.3201 26.265 23.7704L19.6012 12.6541C19.2797 12.1175 19.119 11.8492 18.9104 11.7587C18.7285 11.6797 18.521 11.6797 18.3391 11.7587C18.1306 11.8492 17.9699 12.1175 17.6548 12.6541Z",
			stroke: "#DC6803",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAlertWarning;
